import * as React from 'react';
import { TrustedShopsConfirmation } from '@grandvisionhq/analytics';
import { Logo, Loader, Card } from '@grandvisionhq/common';
import { Heading, Divider } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { ErrorPage } from '@grandvisionhq/layout';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { OrderConfirmHeroBanner } from './components/OrderConfirmHeroBanner/OrderConfirmHeroBanner.js';
import { OrderDetailsSummary } from './components/OrderDetailsSummary/OrderDetailsSummary.js';
import { OrderPaymentSummary } from './components/OrderPaymentSummary/OrderPaymentSummary.js';
import { OrderConfirmDeliveryIndicatorContainer } from './components/OrderConfirmDeliveryIndicator/OrderConfirmDeliveryIndicatorContainer.js';
import { OrderLineItemsSummaryContainer } from './components/OrderLineItemsSummary/OrderLineItemsSummaryContainer.js';
import { LineItemsContainer } from './container/LineItemContainer.js';
import { useOrderedProductDetailSlot } from './slots/context.js';

const OrderConfirm = ({ order , logo , labels , contains , isLoading , error , isTrustedShopsCheckout ,  })=>{
    const { getLabel  } = useIntl();
    const { Slots  } = useOrderedProductDetailSlot();
    const link = useLink({
        route: 'home'
    });
    const { isCartDeliveryIndicatorEnabled  } = useFeatureToggles();
    const { currency  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm"
    }, /*#__PURE__*/ React.createElement("header", {
        className: "orderConfirm__header"
    }, logo && /*#__PURE__*/ React.createElement(Logo, {
        url: "/",
        image: logo,
        title: logo.altText,
        className: "orderConfirm__logo"
    })), isTrustedShopsCheckout && order && /*#__PURE__*/ React.createElement(TrustedShopsConfirmation, {
        order: order,
        currency: currency
    }), error && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ErrorPage, {
        header: getLabel('common.pageNotFound.header'),
        subheader: getLabel('common.pageNotFound.subheader'),
        buttonText: getLabel('cart.actions.goBack'),
        buttonHref: link === null || link === void 0 ? void 0 : link.href
    })), !order && isLoading && /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__loading"
    }, /*#__PURE__*/ React.createElement(Loader, null)), order && !isLoading && /*#__PURE__*/ React.createElement("main", {
        className: "orderConfirm__main"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__hero"
    }, /*#__PURE__*/ React.createElement(OrderConfirmHeroBanner, {
        orderNumber: order.orderNumber,
        labels: labels,
        contains: contains,
        paymentStatus: order.paymentStatus,
        paymentMethod: order.paymentMethod.value,
        donationIntent: order.donationIntent
    })), /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__detailsContainer"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__summaries"
    }, /*#__PURE__*/ React.createElement(OrderDetailsSummary, {
        labels: labels,
        orderData: order
    })), /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__lineItem"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, labels.orderDetailsHeader), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Section, null, Slots.FirstComponent ? /*#__PURE__*/ React.createElement(Slots.FirstComponent, {
        order: order
    }) : isCartDeliveryIndicatorEnabled ? /*#__PURE__*/ React.createElement(OrderConfirmDeliveryIndicatorContainer, {
        lineItems: order.lineItems
    }) : null), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(LineItemsContainer, {
        lineItems: order === null || order === void 0 ? void 0 : order.lineItems
    })), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(OrderPaymentSummary, {
        paymentMethod: order.paymentMethod.label,
        paymentDetails: order.paymentDetails
    })), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(OrderLineItemsSummaryContainer, {
        order: order
    }))))))));
};

export { OrderConfirm };
//# sourceMappingURL=OrderConfirm.js.map
